import "../../../assets/css/style.css";

import React, { useRef, useState } from "react";
import { Routes, Route, useNavigate, useLocation, matchPath } from "react-router-dom";
import { DimensionsPage } from "./builder/dimensions_page";
import { useStoreSelector } from "../../../../hooks/StoreHooks";
import { LayoutPage } from "../../../../components/Layout/layoutPage";
import TopBar from "../../../../components/TopBar/TopBar";
import { getProductName } from "../../../../Utility";
import CloseIcon from '@mui/icons-material/Close';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import { I18n } from "../../../../i18n";
import { AspectPage } from "./builder/aspect_page";
import { Button } from "@mui/material";
import { ConfigurationStepper } from "../../../ui/components/configuration_stepper";
import DialogsProvider, { useDialogs } from "../../../providers/dialogs_provider";
import DialogChiusureProvider from "./provider/dialog_chiusure_provider";
import { PergolaConfigurationLoadPage } from "./builder/pergola_configuration_load_page";
import { ConditionsPage } from "./builder/conditions_page";
import { useConfigurationsService } from "../../../services/configurations_service";
import { getCurrentUser } from "../../../core/common_functions";
import Loading from "../../../../components/Loading/loading";
import { BuildPage } from "./builder/build_page";
import FinishProvider from "../../../providers/finish_provider";
// stack
import { useNavigationStack } from "../../../providers/NavigationContext";
import { IlluminationPage } from "./builder/illumination_page";
import { FiorierePage } from "./builder/fioriera_page";
import { ChiusuraPage } from "./builder/chiusure/chiusure_page";
import ChiusureProvider from "./provider/chiusure_provider";
import TeliProvider from "./provider/teli_provider";
import { MainPage } from "./builder/main_page";
import { ConfigurationStepperPergola } from "../../../ui/components/configuration_stepper_pergola";
import Select from "./builder/forma_pergola_page";
import { RilievoPage } from "./builder/rilievo_page";
import { OtherAccessoriesPage } from "./builder/other_component";
import { QuotePage } from "./builder/quote_pergola";
import { RilievoRecapPage } from "./builder/prelievo_quote";

export const PergolaConfigurationsRoutes = () => {
  const { stack, goToStack, getLastIndex } = useNavigationStack();
  const navigate = useNavigate();
  const location = useLocation();
  const { base, pergolaConfigurationBuilder } = useStoreSelector(store => store);
  const currentUser = getCurrentUser(base);
  const headerRef = useRef<HTMLDivElement | null>(null);
  const [isDelete, setDelete] = useState<boolean>(false);
  const [deleteClickCount, setDeleteClickCount] = useState<number>(0);
  const configurationService = useConfigurationsService();
  const dialogs = useDialogs();

  const deleteConfiguration = async () => {
    if (deleteClickCount === 0) {
      setDeleteClickCount(1);
      setTimeout(() => setDeleteClickCount(0), 5000);
    } else if (deleteClickCount === 1) {
      setDelete(true);
      try {
        if (!pergolaConfigurationBuilder.configuration) throw "invalid configuration";
        await configurationService.delete(currentUser, pergolaConfigurationBuilder.configuration.configurationId);

        navigate("/configurations");
      } catch (e: any) {
        setDelete(false);

        if (typeof e === "string") {
          dialogs?.showError("Attenzione...", e);
        } else {
          if (e.severity === "error") {
            dialogs?.showError("Attenzione...", e.message);
          } else if (e.severity === "warning") {
            dialogs?.showWarning("Attenzione...", e.message);
          }
        }
      }
    }
  };

  if (isDelete) return <Loading />;

  return (
    <I18n locale={base.locale}>
      <LayoutPage>
        <div ref={headerRef} style={{ flex: "0 0 auto" }}>
          <TopBar />
          <div className={"d-flex justify-content-between p-3"}>
            <div className="d-flex flex-column" style={{ lineHeight: "1" }}>
              <h2 className="h2 fw-bold">
                Nuova Pergola{getProductName(pergolaConfigurationBuilder.configuration?.categoryCode)} (#
                {pergolaConfigurationBuilder.configuration?.configurationId})
              </h2>
            </div>
            <div>
              <Button variant={deleteClickCount === 0 ? "outlined" : "contained"} color="error" className="me-3 px-2" onClick={deleteConfiguration}>
                <RemoveCircleOutlineOutlinedIcon />
                <span className="ms-2">{deleteClickCount === 0 ? "ELIMINA" : "CONFERMA"}</span>
              </Button>

              <Button variant="contained" color="secondary" onClick={() => goToStack(getLastIndex())}>
                <CloseIcon />
                <span className="ms-2">CHIUDI</span>
              </Button>
            </div>
          </div>
          {!(matchPath({ path: "/pergola-configurations/:id/preventivo" }, location.pathname) ||  matchPath({ path: "/pergola-configurations/:id/selezione" }, location.pathname) ||  matchPath({ path: "/pergola-configurations/:id/rilievo" }, location.pathname)) && (
            <ConfigurationStepperPergola
              area={"pergola-configurations"}
              steps={[
                { title: "Dimensioni", slug: "dimensioni", image: "https://media.deltaoverlap.com/public/img/Icone/Dimensioni.png", isActive: false, isComplete: false, isVisible: false,callback: true },
                { title: "Rilievo", slug: "rilievo", image: "https://media.deltaoverlap.com/public/img/Icone/Dimensioni.png", isActive: false, isComplete: false, isVisible: false,callback: true },
                { title: "Aspetto", slug: "aspetto", image: "https://media.deltaoverlap.com/public/img/Icone/Aspetto.png", isActive: false, isComplete: false, isVisible: false,callback:true },
                { title: "Chiusure", slug: "chiusure", image: "https://media.deltaoverlap.com/public/img/Icone/Aspetto.png", isActive: false, isComplete: false, isVisible: false,callback: true },
                { title: "Illuminazioni", slug: "illuminazioni", image: "https://media.deltaoverlap.com/public/img/Icone/Aspetto.png", isActive: false, isComplete: false, isVisible: false,callback: true },
                { title: "Fioriere", slug: "fioriere", image: "https://media.deltaoverlap.com/public/img/Icone/Aspetto.png", isActive: false, isComplete: false, isVisible: false,callback: true },
                { title: "Personalizzazioni", slug: "estetica", image: "https://media.deltaoverlap.com/public/img/Icone/Aspetto.png", isActive: false, isComplete: false, isVisible: false,callback: true },
                { title: "Accessori vari", slug: "accessori-vari", image: "https://media.deltaoverlap.com/public/img/Icone/Aspetto.png", isActive: false, isComplete: false, isVisible: false,callback: true },
                { title: "Condizioni", slug: "condizioni", image: "https://media.deltaoverlap.com/public/img/Icone/Richiesta.png", isActive: false, isComplete: false, isVisible: false,callback: false },
              ]}
            />
          )}
        </div>

        <div style={{ flex: "1 1 auto", minHeight: "0" }}>
          <DialogsProvider>
            <DialogChiusureProvider>
              <FinishProvider>
                <ChiusureProvider>
                  <TeliProvider>
                    <Routes>
                    <Route path="/:id" element={<PergolaConfigurationLoadPage />} />
                    <Route path="/:id/selezione" element={<Select />} />
                    <Route path="/:id/rilievo" element={<RilievoPage />} />
                    <Route path="/:id/dimensioni" element={<MainPage />} />
                    <Route path="/:id/aspetto" element={<MainPage />} />
                    <Route path="/:id/chiusure" element={<MainPage />} />
                    <Route path="/:id/illuminazioni" element={<MainPage />} />
                    <Route path="/:id/estetica" element={<MainPage />} />
                    <Route path="/:id/fioriere" element={<MainPage />} />
                    <Route path="/:id/accessori-vari" element={<OtherAccessoriesPage />} />
                    <Route path="/:id/generazione-preventivo" element={<BuildPage />} />
                    <Route path="/:id/condizioni" element={<ConditionsPage />} />
                    <Route path="/:id/preventivo" element={<QuotePage />} />
                    <Route path="/:id/rilievo_preventivo" element={<RilievoRecapPage />} />
                    <Route path="*" element={<p>Not found</p>} />
                    </Routes>
                  </TeliProvider>
                </ChiusureProvider>
              </FinishProvider>
            </DialogChiusureProvider>
          </DialogsProvider>
        </div>
      </LayoutPage>
    </I18n>
  );
};
